/**
 * Variantes de taille des photos de profil X.
 *
 * L'API ne renvoie que la variante `_normal` : 48 × 48 px — floue sur toute
 * vignette au-delà, et l'app en affiche jusqu'à ~220 px physiques (grille des
 * Suivis à dpr 3) et en cuit de plus grandes encore dans les textures GL. Le
 * même CDN sert `_bigger` (73), `_200x200` et `_400x400` par simple réécriture
 * du suffixe : zéro appel API, zéro resynchro, on transforme au rendu.
 *
 * On ne touche qu'aux URLs qui portent effectivement le suffixe `_normal`
 * (les avatars de substitution du banc sont des data-URIs, les avatars par
 * défaut de X n'ont pas toujours de variantes) — tout le reste passe tel quel.
 * On ne demande jamais l'original sans suffixe : il peut peser des mégaoctets.
 */

export type AvatarVariant = "bigger" | "200x200" | "400x400";

export function avatarVariant(
  url: string | null | undefined,
  variant: AvatarVariant,
): string | null {
  if (!url) return null;
  if (!/_normal\.(jpg|jpeg|png|gif|webp)$/i.test(url)) return url;
  return url.replace(/_normal(\.[a-z]+)$/i, `_${variant}$1`);
}

/**
 * La variante qui couvre une vignette de `sizePx` px CSS sans flou : on vise
 * la taille physique (dpr plafonné à 3, comme le rendu GL) et on prend la
 * première variante au-dessus.
 */
export function avatarForSize(url: string | null | undefined, sizePx: number): string | null {
  const physical = sizePx * Math.min(window.devicePixelRatio || 1, 3);
  if (physical <= 73) return avatarVariant(url, "bigger");
  if (physical <= 200) return avatarVariant(url, "200x200");
  return avatarVariant(url, "400x400");
}
